import 'antd/dist/antd.less'
import '@eura/uicomponent-lib/styles/global.scss'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import App from './components/app'

export default App
